import { setShowEstimateDuplicateModal } from '../State/showEstimateDuplicateModal';

export default () => async (dispatch) => {

  dispatch(setShowEstimateDuplicateModal(false));
  
}